import {
  isBetMarketUpdateEnabled as _isBetMarketUpdateEnabled,
  BetMarketType,
} from '@collector/shared-domain'
import { IncidentId } from '@collector/sportsapi-client-legacy'

import { useEvent } from '../../composables'
import { BlockedIncidentsMap } from '../configuration/blockedIncidentsMap'
import { injectPitchBlockedEventStatus } from '../provide-inject'

export function useBlockades(): {
  isIncidentBlocked(
    incidentId: IncidentId,
    blockedIncidentsMap: BlockedIncidentsMap,
  ): boolean
  isPitchBlocked(): boolean
  isBetMarketUpdateEnabled(market: BetMarketType): boolean
} {
  const { event, hasEventCurrentStatus } = useEvent()

  const pitchBlockedEventStatus = injectPitchBlockedEventStatus()

  function isIncidentBlocked(
    incidentId: IncidentId,
    blockedIncidentsMap: BlockedIncidentsMap,
  ): boolean {
    const blockedIncidents = blockedIncidentsMap.get(event.value.status_id)

    if (!blockedIncidents) {
      return false
    }

    // searching in Set - O(1)
    return blockedIncidents.has(incidentId)
  }

  function isPitchBlocked(): boolean {
    return hasEventCurrentStatus(pitchBlockedEventStatus)
  }

  function isBetMarketUpdateEnabled(market: BetMarketType): boolean {
    return _isBetMarketUpdateEnabled(event.value, market)
  }

  return {
    isIncidentBlocked,
    isPitchBlocked,
    isBetMarketUpdateEnabled,
  }
}
